module.exports = __webpack_public_path__ + "img/Etape 3.792b48f1.png";